<template lang="pug">
  .liaoning-flow
    .header
      img(src="../../../public/images/chongqing/marheader.png")
    .form
      el-form
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入重庆移动手机号")
        el-form-item
          el-col(:span="15")
            el-input(type="text", v-model="form.verifyCode", placeholder="请输入验证码", maxlength="6")
          el-col(:span="9")
            el-button(type="primary", :disabled="leftSendTime > 0", @click="sendVerifyCode")
              span(v-if="leftSendTime <= 0") 获取验证码
              span(v-else) {{leftSendTime}}秒后重试
        el-form-item.button-item
          el-button(type="warning", @click="handelConfirm") 立即办理
    .notice
      .title - 活动规则 -
      .content
        ul
          li(v-for="(notice, index) in notices", :key="index", v-if="index <= 1 || showMoreNotice")
            .num {{index + 1}}.
            p.content(v-if="typeof(notice) === 'string'") {{notice}}
            p.content(v-else)
              | {{notice.text}}
              ul
                li(v-for="childItem in notice.children", :key="childItem") {{childItem}}
        .show-more(v-if="!showMoreNotice", @click="showMoreNotice = true") 点击查看更多活动规则
    el-dialog(
      width="80%",
      title="提示",
      :visible.sync="dialogVisible"
    )
      .dialog-content
        div
          | 您要为手机号：
          span.mobile-info {{form.mobile}}
        div
          | 办理业务：
          span.package-info 30元10G极速流量包-18个月合约版
      span.dialog-footer(slot="footer")
        el-button(@click="dialogVisible = false") 取消
        el-button(type="primary", @click="handleSubmit") 确定
</template>

<script>
export default {
  data() {
    return {
      leftSendTime: 0,
      notices: [
        '业务资费：5G畅享权益包，本产品采用话费支付，订购立即生效，资费30元/月，合约期12个月，合约期内不能取消。合约到期后，如不取消按30元/月续订（可在合约期最后一月取消，退订次月生效）。合约期内不能办理过户、销户、合户、分户和停机保号业务，若因特殊原因需提前取消业务，请前往营业厅处理进行费用清算，提前取消业务需按照30元/月*未履约时长赔付。',
        {
          text: '本产品权益：',
          children: [
            '(1) 本产品包含10GB流量（5GB全国通用流量(不含港澳台)+ 5GB定向流量）。流量到账当月内有效，不可共享/转赠/结转。',
            '(2) 本产品定向流量月包（自然月，非30天），支持在优酷、百度系、爱奇艺、今日头条、抖音、咪咕视频、快手使用。',
            '(3) 每自然月内可领取一个会员权益。成功领取后会员有效期30天，会员有效期在您原有会员有效期上顺延。',
            '(4) 本产品包含5G优享网速权益，使用5G手机在5G网络覆盖区域即可体验5G网速权益。',
            '(5) 本产品权益包含家庭云盘（200G）、视频彩铃（基础功能）、云VR体验权益（以上三个权益均为体验3个月），到期自动取消不收取费用。',
          ]
        },
        {
          text: '权益领取规则：',
          children: [
            '(1) 业务生效期间，每自然月1日起至月底，您可领取当月权益。领取机会当月有效，当月未领则作废不积累至下月，即未领取次月不能补领。',
            '(2) 会员VIP领取后30分钟内充值到账。领取成功后，会员VIP时长将在您原有会员时长上顺延。请直接使用手机号码、验证码登录APP查看您的会员VIP到账情况。',
          ]
        },
        '权益领取范围：爱奇艺月会员、腾讯视频月会员、优酷月会员、哔哩哔哩月会员、芒果TV月会员、咪咕视频月会员、酷狗音乐月会员、QQ音乐月会员、酷我音乐月会员、咪咕音乐月会员、掌阅月会员、喜马拉雅月会员、QQ阅读月会员、蜻蜓FM月会员、咪咕阅读月会员（具体以权益领取页面为准），业务生效期间每月可从多项VIP会员权益中任选一个使用。',
        '权益领取入口：本产品订购生效后可在重庆移动手厅“我的”—“我的权益”登录领取权益。',
        '本产品限重庆移动客户办理，数据卡、物联网卡、欠费、停机、及手机状态不正常的客户不可办理本业务。'
      ],
      form: {
        mobile: '',
        verifyCode: '',
        carrierId: 15,
        userId: '',
        goodsCode: 'TUIA062900019999'
      },
      channel: 'TUIA',
      showMoreNotice: true,
      dialogVisible: false,
      agreeProtocol: true,
      protocolVisible: false
    }
  },
  mounted () {
    if (this.$route.query.action === 'redirect') {
      location.href = 'https://y.app.10086.cn/YXMB/v3/api/api/pro/2f51a490168a4fe5'
    }
  },
  methods: {
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel
        })
        .then(res => {
          if (res.data.success) {
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    handelConfirm() {
      this.dialogVisible = true
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    handleSubmit() {
      this.dialogVisible = false
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.selectedPackage.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            try{
              // eslint-disable-next-line
              if (window.countLog) {
                // eslint-disable-next-line
                countLog.ready(function() {
                  // eslint-disable-next-line
                  countLog.init(function() { 
                    // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
                  }, {
                    // 是否需要复制订单号，是为 1，不是为 0 
                    isCopy: 0, 
                    // 上报转化类型，具体见下表 
                    pageType: 0 
                  })
                })
              }
            } catch (err) {
              console.log(err)
              this.errlog = err.message;
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            this.$router.push({
              name: 'sichuanSuccess'
            })
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.liaoning-flow{
  background-color: #41c1ac;
  padding-bottom: 3.5rem;
}
.header{
  img{
    width: 100%;
  }
}
.notice{
  margin-top: 2 rem;
  font: "黑体", "Arial";
  .title{
    text-align: center;
    color: #fff;
    margin-bottom: .5rem;
  }
  >.content{
    background: url('../../assets/images/liaoning/notice-bg.png') no-repeat;
    background-size: 100% 100%;
    padding: 2.5rem 2rem 1.2rem;
    border-radius: .4rem;
    margin: 0 auto;
    width: 82%;
    ul{
      li{
        clear: both;
        overflow: hidden;
        font-size: .8rem;
        color: #4A9F94;
        margin-bottom: .2rem;
        .num{
          float: left;
          width: 1.4rem;
          line-height: 1.2rem;
        }
        .content{
          line-height: 1.2rem;
          margin-left: 1.3rem;

        }
      }
    }
    .show-more{
      text-align: center;
      font-size: .8rem;
      color: #a3a3a3;
    }
  }
}
.form{
  width: 80%;
  margin: 0 auto;
  margin-top: -3rem;
  .button-item{
    text-align: center;
    .el-button{
      width: 100%;
    }
  }
}
.protocol-content{
  color: #333;
  margin-left: .5rem;
  .protocol{
    color: rgb(48, 113, 253);
  }
}
.protocol-dialog-content{
  font-size: .6rem;
  text-align: left;
  >div{
    text-indent: 1rem;
  }
}
</style>
